import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { UntilDestroy } from '@ngneat/until-destroy';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs';

import { fromRouterSelectors } from '@tsq-web/router';
import { AppState } from '@tsq-web/state';
import { fromUserContextActions, fromUserContextSelectors } from '@tsq-web/user-context';

import { LoginSsoErrorTypes } from '../../models/login-sso-error-types.enum';

@UntilDestroy()
@Component({
  selector: 'comm-sso-callback',
  templateUrl: './callback.component.html',
})
export class SingleSignOnCallbackComponent implements OnInit {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly router = inject(Router);
  private readonly specificErrorTypes = [
    LoginSsoErrorTypes.AccessDenied,
    LoginSsoErrorTypes.OauthFailed,
  ];

  protected readonly loggingIn$ = this.store.pipe(
    select(fromUserContextSelectors.selectUserLoggingIn),
  );

  ngOnInit(): void {
    this.store
      .select(fromRouterSelectors.selectRouterQueryParams)
      .pipe(take(1))
      .subscribe(params => {
        if (!!params.code) {
          this.store.dispatch(fromUserContextActions.authTokenExchangeV0({ code: params.code }));
        }
        if (!!params.error) {
          const ssoErrorType = this.mapErrorToSsoErrorType(params.error);

          const decodedState = decodeURIComponent(params.state);
          const parsedState = JSON.parse(decodedState);
          const emailFromState = parsedState.email;

          this.router.navigate(['/login'], {
            queryParams: { ssoErrorType: ssoErrorType, email: emailFromState },
          });
        }
      });
  }

  private mapErrorToSsoErrorType(error: string): string {
    return this.specificErrorTypes.includes(error as LoginSsoErrorTypes)
      ? error
      : LoginSsoErrorTypes.OtherErrors;
  }
}
